import React, { useState, useEffect } from 'react';
import './App.css';

const projects = [
  { id: 1, title: 'E-Commerce Platform', tech: 'React · Node.js · MongoDB', desc: 'Full-stack shopping experience with real-time inventory.' },
  { id: 2, title: 'AI Dashboard', tech: 'React · Python · FastAPI', desc: 'Analytics dashboard with live ML model monitoring.' },
  { id: 3, title: 'Mobile Banking App', tech: 'React Native · Firebase', desc: 'Secure banking UI with biometric authentication.' },
];

export default function App() {
  const [active, setActive] = useState(null);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="root">
      <nav className={`nav ${scrolled ? 'nav--scrolled' : ''}`}>
        <span className="nav-logo">AK<span className="dot">.</span></span>
        <div className="nav-links">
          <a href="#work">Work</a>
          <a href="#about">About</a>
          <a href="#contact" className="btn-nav">Hire Me</a>
        </div>
      </nav>

      <section className="hero">
        <div className="hero-bg" />
        <div className="hero-content">
          <p className="hero-eyebrow">Full-Stack Developer</p>
          <h1 className="hero-title">
            Arjun<br /><span className="hero-accent">Kapoor</span>
          </h1>
          <p className="hero-sub">
            I craft fast, beautiful web experiences<br />that people actually love to use.
          </p>
          <div className="hero-cta">
            <a href="#work" className="btn-primary">View My Work</a>
            <a href="#contact" className="btn-ghost">Get in Touch</a>
          </div>
        </div>
        <div className="hero-orb orb1" />
        <div className="hero-orb orb2" />
      </section>

      <section className="section" id="work">
        <div className="container">
          <h2 className="section-title">Selected <span className="accent">Work</span></h2>
          <div className="projects-grid">
            {projects.map(p => (
              <div
                key={p.id}
                className={`card ${active === p.id ? 'card--active' : ''}`}
                onMouseEnter={() => setActive(p.id)}
                onMouseLeave={() => setActive(null)}
              >
                <div className="card-num">0{p.id}</div>
                <h3 className="card-title">{p.title}</h3>
                <p className="card-tech">{p.tech}</p>
                <p className="card-desc">{p.desc}</p>
                <div className="card-arrow">→</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section section--dark" id="about">
        <div className="container about-grid">
          <div className="about-text">
            <h2 className="section-title">About <span className="accent">Me</span></h2>
            <p>I am a Mumbai-based developer with 4+ years of experience building scalable web apps. I love clean code, great design, and solving hard problems.</p>
            <p>When not coding, I am hiking or experimenting with generative art.</p>
          </div>
          <div className="skills">
            {['React', 'Node.js', 'TypeScript', 'Python', 'PostgreSQL', 'Docker'].map(s => (
              <span key={s} className="skill-tag">{s}</span>
            ))}
          </div>
        </div>
      </section>

      <section className="section" id="contact">
        <div className="container contact-center">
          <h2 className="section-title">Let us <span className="accent">Talk</span></h2>
          <p className="contact-sub">Open for freelance projects and full-time roles.</p>
          <a href="mailto:arjun@example.com" className="btn-primary btn-large">arjun@example.com</a>
        </div>
      </section>

      <footer className="footer">
        <span>2026 Arjun Kapoor</span>
        <span>Built with React - Hosted on Hostinger</span>
      </footer>
    </div>
  );
}
